import http from './service/http-service'

// 下载复用业务请求的认证头，但保留文件内容和响应头，不解包 res.data。
const downloadHttp = http.create({
  baseURL: http.defaults.baseURL,
  paramsSerializer: http.defaults.paramsSerializer,
  timeout: 120000
})
downloadHttp.interceptors.request.use(http.defaults.onReqSuccess, http.defaults.onReqError)

export default downloadHttp



// WEBPACK FOOTER //
// ./src/http.js